import CompletedProjectProposalViewList from './ViewList';

export default CompletedProjectProposalViewList;
